export default __webpack_public_path__ + "static/media/placeholder.a54c894e.png";